import Icons from '@/shared/components/icon/Icons'
import { Caption } from '@/shared/components/typography/index'

interface ShowAllProps {
  onClick: () => void
  bottom?: string
}
const ShowAllButton = ({ onClick, bottom }: ShowAllProps) => {
  return (
    <div className={`absolute ${bottom ? bottom : `bottom-[-24px]`} flex w-full cursor-pointer flex-col`}>
      <div className="h-[22px] w-full bg-transparent bg-gradient-to-t from-[#ffffff]" />
      <div className="flex h-[70px] w-full items-center justify-center bg-010" onClick={onClick}>
        <Caption level="caption1" weight="regular" color="text070" className="my-[24px] h-[22px]">
          전체 보기
        </Caption>
        <div className="ml-[6px] h-[16px] w-[16px]">
          <Icons.DownArrowIcon stroke="currentColor" color="#6D7D90" className="cursor-pointer" />
        </div>
      </div>
    </div>
  )
}

export default ShowAllButton
